import React, { Component } from 'react'
import { connect } from 'react-redux'
import { selectAgentTrainingCenterTopics } from 'manager/selectors/auth'
import { createStructuredSelector } from 'reselect'
import { setTitle } from 'common/redux/root'
import { push } from 'react-router-redux'
import { TrainingCard } from 'manager/views/components/Training/TrainingCard'
import styled from 'styled-components'

export class TrainingHomeContainer extends Component {

  componentDidMount() {
    const { setTitle } = this.props

    setTitle(null)
  }


  render() {
    const { push, trainingCenterTopics } = this.props

    if (trainingCenterTopics.length < 1) {
      return null
    }

    return (
      <TrainingHome>
        <TrainingHomeContent>
          <TrainingHomeContentHeader>
            <span>How can we help you?</span>
          </TrainingHomeContentHeader>
          <TrainingHomeContentSubheader>
            <span>Choose a category to find the help you need</span>
          </TrainingHomeContentSubheader>
          <TrainingHomeCards>
            {trainingCenterTopics.map(topic => {
              const onClick = () => push({pathname:`/training/${topic.slug}`})
              return (<TrainingCard key={topic.slug} {...topic} onClick={onClick} />)
            }
            )}
          </TrainingHomeCards>
        </TrainingHomeContent>
        <TrainingHomeFooter>
          <span>Have any technical issues? Visit our <a href='https://support.realtor.com/s/opcity-for-agents' target="_blank" rel="noopener noreferrer">Support Portal</a> to submit help requests.</span>
        </TrainingHomeFooter>
      </TrainingHome>
    )
  }
}

const selectors = createStructuredSelector({
  trainingCenterTopics: selectAgentTrainingCenterTopics,
})

const actions = {
  push,
  setTitle
}


export default connect(selectors, actions)(TrainingHomeContainer)

const TrainingHome = styled.div`
flex: 1;
height: 100%;
background-color: #F8F8F9;
`

const TrainingHomeContent = styled.div`
padding-top: 70px;
`

const TrainingHomeContentHeader = styled.div`
display: flex;
align-items: center;
justify-content: center;
text-align: center;

span {
  font-family: 'Circular';
  font-weight: 700;
  font-size: 36px;
  color: #4A4A4A;
}
`

const TrainingHomeContentSubheader = styled.div`
display: flex;
align-items: center;
justify-content: center;
padding-top: 34px;

span {
  font-family: 'Circular';
  font-weight: 'light';
  font-size: 26px;
  color: #8c8c8c;
}

@media(max-width: 980px) {
  display: none;
}
`

const TrainingHomeFooter = styled.div`
display: flex;
align-items: center;
justify-content: center;
padding: 70px 5%;
text-align: center;
background-color: #F8F8F9;

span {
  font-family: 'Circular';
  font-weight: 300;
  font-size: 20px;
  color: #4A4A4A;
}

a {
  font-family: 'Circular';
  font-weight: 500;
  text-decoration: none;
  color: #0588DD;
}
`

const TrainingHomeCards = styled.div`
display: flex;
margin: auto;
align-items: center;
flex-direction: row;
justify-content: center;
padding-top: 20px;
padding-bottom: 100px;
max-width: 1800px;
flex-wrap: wrap;
border-bottom: 1px solid #D9D9D9;
background-color: #f8f8f9;

@media(max-width: 980px) {
  justify-content: center;
}
`

